<template>
	<n-modal
		v-model:show="show"
		header-class="pb-2!"
		class="w-[90vw]! max-w-105!"
		preset="card"
		size="large"
		:auto-focus="false"
	>
		<template #header>
			<div class="text-lg font-bold">{{ $t(`exams.reports.share.title`) }}</div>
		</template>
		<template #default>
			<div v-if="props.data" class="flex flex-col gap-2">
				<div v-if="props.data.filename">{{ props.data.filename }}</div>
				<p class="text-secondary text-sm">{{ $t(`exams.reports.share.info`) }}</p>

				<div class="mt-4 flex flex-col gap-4">
					<n-form-item label="Link" :show-feedback="false">
						<n-input :value="link" readonly>
							<template v-if="isSupported" #suffix>
								<n-tooltip trigger="hover">
									<template #trigger>
										<n-button text @click="copyText(link)">
											<template #icon>
												<Icon name="carbon:copy" :size="16" class="ml-1" />
											</template>
										</n-button>
									</template>
									{{ $t(`common.misc.copy`) }}
								</n-tooltip>
							</template>
						</n-input>
					</n-form-item>
					<n-form-item label="Password" :show-feedback="false">
						<n-input :value="password" readonly>
							<template v-if="isSupported" #suffix>
								<n-tooltip trigger="hover">
									<template #trigger>
										<n-button text @click="copyText(password)">
											<template #icon>
												<Icon name="carbon:copy" :size="16" class="ml-1" />
											</template>
										</n-button>
									</template>
									{{ $t(`common.misc.copy`) }}
								</n-tooltip>
							</template>
						</n-input>
					</n-form-item>
				</div>
			</div>
		</template>
	</n-modal>
</template>

<script lang="ts" setup>
import type { I18nString } from "@/lang/config"
import type { ExamReport } from "@/types/exam"
import { useClipboard } from "@vueuse/core"
import { NButton, NFormItem, NInput, NModal, NTooltip, useMessage } from "naive-ui"
import { watch } from "vue"
import { useI18n } from "vue-i18n"
import Icon from "@/components/common/Icon.vue"

const props = defineProps<{ data: Partial<ExamReport> | null }>()
const show = defineModel<boolean>("show", { default: false })

// TODO-NEXT: MVP2 implementare la condivisione del report
const message = useMessage()
const { t } = useI18n()

const link = "https://share.justmum.xyz/report/knewvrbnoblvrl"
const password = "OI4GU8OG-OF3IU6IF-OI4GU5VU"

const { copy, copied, isSupported } = useClipboard()

function copyText(text: string) {
	copy(text)
}

watch(copied, val => {
	if (val) {
		message.success(t<I18nString>(`common.misc.copied`))
	}
})
</script>
